// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aPbzg","title":"styles_title__1t9tt"};